import styled from 'styled-components';

export const Wrapper = styled.div`
    margin: 0;

    ul {
        padding-left: 0;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        margin-top: 0;
        width: 100%;
    }

    li {
        margin: 5px 0;
        list-style-position: inside;
        display: inline-block;

        width: 33%;

        @media (max-width: 768px) {
            width: 50%;
        }

        @media (max-width: 425px) {
            width: 100%;
        }
    }

    li:before {
        content: '• ';
    }
`;
